;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputUsersController', InputUsersController)

  /* @ngInject */
  function InputUsersController ($scope, $attrs, $timeout, UdsModalService) {
    const getUpgradeCompanyPlanDialogController = () => import('../../dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

    $scope.moreTooltipContent = ''

    const api = {
      _openUpgradeCompanyPlanDialog,
      _setMoreTooltipContent,
      getUpgradeCompanyPlanDialogController
    }
    this.getApi = () => api

    activate()

    function activate () {
      $timeout(() => {
        const dropdownParams = {
          action: 'nothing',
          direction: $scope.direction || 'downward',
          fullTextSearch: true
        }

        if ($scope.close) {
          dropdownParams.onHide = $scope.close
        }
        if (!$scope.pricing) {
          $attrs.$$element.find('.input-users-dropdown').dropdown(dropdownParams)
        }

        if ($scope.titleTooltip) {
          $attrs.$$element.find('.input-users-tooltip').popup()
        }
      }, 100, false)
    }

    $scope.isUserSelected = function (userId) {
      if (!$scope.model) {
        return false
      }
      if ($scope.single) {
        return $scope.model.id && $scope.model.id === userId
      }
      return $scope.model.some(user => user.id === userId)
    }

    $scope.handleSelectUser = function (user) {
      if ($scope.single) {
        if ($scope.model && $scope.model.id === user.id) {
          $scope.model = null
        } else {
          $scope.model = user
        }
        if ($attrs && $attrs.$$element.find('.input-users-dropdown')) {
          $attrs.$$element.find('.input-users-dropdown').dropdown('hide')
        }
        return
      }

      const index = $scope.model.findIndex(selectedUsr => selectedUsr.id === user.id)
      if (index !== -1) {
        $scope.model.splice(index, 1)
      } else {
        $scope.model.push(user)
      }
    }

    $scope.validatePricingClick = function () {
      if ($scope.pricing?.showPrincing) {
        api._openUpgradeCompanyPlanDialog($scope.pricing)
      }
    }

    $scope.shouldShowUser = function (index) {
      if (!$scope.maxVisible) return true
      if (index + 1 === $scope.maxVisible && $scope.model.length > $scope.maxVisible) {
        return false
      }
      if (index >= $scope.maxVisible) return false
      return true
    }

    $scope.onLastRepeatItem = function () {
      api._setMoreTooltipContent()
    }

    function _setMoreTooltipContent () {
      $scope.moreTooltipContent = ''

      $scope.model.forEach((user, index) => {
        const maxVisibleOnTooltipContent = 36

        if (index >= maxVisibleOnTooltipContent) return
        $scope.moreTooltipContent += `<div>${user.name}</div>`
      })
    }

    function _openUpgradeCompanyPlanDialog (pricingData) {
      api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
        const upgradeCompanyPlanDialog = UdsModalService.createModal({
          controller: UpgradeCompanyPlanDialogController,
          modalName: 'upgradeCompanyPlanDialog',
          data: {
            featureName: pricingData.name,
            featureSlug: pricingData.slug
          }
        })
        upgradeCompanyPlanDialog.open()
      })
    }

    $('input').on('input', (evt) => {
      if (!$scope.localSearch) return

      const searchTerm = evt?.target?.value
      $scope.handleLocalSearch({ searchTerm })
    })
  }
})()
